export const dateRangePickerYearsClasses = {
  selected: 'date-year--selected',
}
